import React, { useEffect, useState,useRef } from "react";
import "./EnhanceWorkflowfilter.css";

import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  TextField,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputAdornment,
  Tooltip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TuneIcon from "@mui/icons-material/Tune";

import MultiSelectDropdown from "../../../EnhanceFilters/MultiSelectDropdown";

import {
  priorities,
  coders,
  files,
  diagnosis,
  drgs,
  speciality,
  funds,
  auditStatus,
  status,
} from "../../../EnhanceFilters/dummyData";
import { useDispatch, useSelector } from "react-redux";
import {
  getDrg,
  getEpisodeIdentifiers,
  getFileNames,
  getPrincipalDiagnosis,
  getSpecialitiesFilter,
  getHealthFund,
  getAuditRuleCategory,
  getStatus,
  REQUEST_STATUS,
  getAuditRuleRefNo,
  getCoderName,
} from "../../../EnhanceFilters/EnhanceFiltersSlice";
import { resetPayload, setPayload } from "../EnhanceWorkflowSlice";
import { mergePayload } from "../../../GenericTable/mergePayload";
import { formatDate } from "../../../GenericTable/ColumnFilter";
import FilterBreadcrumbs, { FILTER_LABELS } from "../../../GenericTable/FilterBreadcrumbs";

// Operator options for display
const operatorOptions = [">", "<", ">=", "<=", "=", "!="];

// Single operator mapping
// const OPERATOR_MAP = {
//   "<": "lt",
//   ">": "gt",
//   "<=": "lte",
//   ">=": "gte",
//   "=": "eq",
//   "!=": "ne",
// };

// // Single helper function to map operator
// const mapOperator = (operator) => {
//   return OPERATOR_MAP[operator] || operator;
// };
// const REVERSE_OPERATOR_MAP = Object.fromEntries(
//   Object.entries(OPERATOR_MAP).map(([symbol, apiVal]) => [apiVal, symbol]),
// );

// const mapOperatorToSymbol = (apiVal) => {
//   return REVERSE_OPERATOR_MAP[apiVal] || apiVal;
// };

const initialState = {
  priority: [],
  episode: [],
  auditRuleReferenceNo: [],
  codername: [],
  file: [],
  principalDiagnosis: [],
  drg: [],
  specialities: [],
  healthfund: [],
  admissionFrom: "",
  admissionTo: "",
  separationFrom: "",
  separationTo: "",
  auditRuleCategory: [],
  status: [],
  losOperator: "",
  los: "",
};

const FieldLabel = ({ children }) => (
  <Typography className="enhance-filter-field-label">{children}</Typography>
);

const EnhanceWorkflowFilterModal = ({ open, onClose,isUnassignedView, isRecalledView }) => {
  const [filters, setFilters] = useState(initialState);
  const prevOpenRef = React.useRef(false);
const fileNameToHeaderIdsRef = useRef({});
  const [dropdownState, setDropdownState] = useState({
    episode: { page: 1, search: "" },
    file: { page: 1, search: "" },
    codername: { page: 1, search: "" },
    principalDiagnosis: { page: 1, search: "" },
    drg: { page: 1, search: "" },
    specialities: { page: 1, search: "" },
    healthfund: { page: 1, search: "" },
    auditRuleCategory: { page: 1, search: "" },
    status: { page: 1, search: "" },
    auditRuleReferenceNo: { page: 1, search: "" },
  });
  const dispatch = useDispatch();
  const isLosDisabled =
    !filters.losOperator || filters.losOperator.length === 0;
  const dropdowns = useSelector((state) => state.enhanceFilters.dropdowns);
  const currentPayload = useSelector(
  (state) => state.codeEnhance.payload
);
const breadcomPayload = useSelector(
  (state) => state.codeEnhance.payload
);
// console.log(breadcomPayload,"breadcomPayload");
// console.log(FILTER_LABELS,"FILTER_LABELS")
  const {
    episode,
    file,
    specialities,
    principalDiagnosis,
    drg,
    healthfund,
    auditRuleCategory,
    status: workflowStatus,
    auditRuleReferenceNo,
    codername,
  } = dropdowns;

  const loadDropdown = (key, thunk) => {
    setDropdownState((prev) => ({
      ...prev,
      [key]: {
        page: 1,
        search: "",
      },
    }));

    dispatch(
      thunk({
        search: "",
        page_number: 1,
        page_size: 10,
      }),
    );
  };
  useEffect(() => {
    if (!open) return;

    loadDropdown("episode", getEpisodeIdentifiers);
    loadDropdown("file", getFileNames);
    loadDropdown("specialities", getSpecialitiesFilter);
    loadDropdown("principalDiagnosis", getPrincipalDiagnosis);
    loadDropdown("drg", getDrg);
    loadDropdown("healthfund", getHealthFund);
    loadDropdown("auditRuleCategory", getAuditRuleCategory);
    loadDropdown("status", getStatus);
    loadDropdown("auditRuleReferenceNo", getAuditRuleRefNo);
    loadDropdown("codername", getCoderName);
  }, [open]);
  const handleSearch = (key, thunk) => (_, value) => {
    setDropdownState((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        search: value,
        page: 1,
      },
    }));

    dispatch(
      thunk({
        search: value,
        page_number: 1,
        page_size: 10,
      }),
    );
  };

// accumulate every time new file options arrive (initial load, search, load more)
useEffect(() => {
  if (file?.data?.length) {
    file.data.forEach((f) => {
      if (!fileNameToHeaderIdsRef.current[f.file_name]) {
        fileNameToHeaderIdsRef.current[f.file_name] = new Set();
      }
      fileNameToHeaderIdsRef.current[f.file_name].add(f.header_id);
    });
  }
}, [file?.data]);
const getModalOwnedIds = () => {
  const s = new Set();
  Object.values(fileNameToHeaderIdsRef.current).forEach((set) =>
    set.forEach((id) => s.add(id)),
  );
  return s;
};
const getModalOwnedNames = () => new Set(Object.keys(fileNameToHeaderIdsRef.current))

  const handleLoadMore = (key, thunk, hasMore) => () => {
    if (!hasMore) return;

    const nextPage = dropdownState[key].page + 1;

    dispatch(
      thunk({
        search: dropdownState[key].search,
        page_number: nextPage,
        page_size: 10,
      }),
    );

    setDropdownState((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        page: nextPage,
      },
    }));
  };

  const handleInput = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setFilters(initialState);
    dispatch(resetPayload());
    dispatch(
      setPayload({
        unassigned_page: isUnassignedView,
        is_flagged: isRecalledView,  
        recall:isRecalledView      
      })
    );
  };
  useEffect(() => {
  const justOpened = open && !prevOpenRef.current;
  prevOpenRef.current = open;

  if (!justOpened) return;

  setFilters({
    priority: (currentPayload.priority_value || []).map((p) => `P${p}`),
    episode: currentPayload.episode_identifier || [],
    file: currentPayload.file_type || [],
    principalDiagnosis: currentPayload.principal_diagonsis || [],
    drg: currentPayload.drg || [],
    specialities: currentPayload.case_mix_speciality || [],
    healthfund: currentPayload.insurer_identifier || [],
    admissionFrom: formatDate(currentPayload.admission_date_from) || "",
    admissionTo: formatDate(currentPayload.admission_date_to) || "",
    separationFrom: formatDate(currentPayload.separation_date_from) || "",
    separationTo: formatDate(currentPayload.separation_date_to) || "",
    auditRuleCategory: currentPayload.audit_rule_category || [],
    codername:currentPayload.username,
    status: currentPayload.status || [],
    auditRuleReferenceNo: currentPayload.audit_ref_no || [],
    losOperator: currentPayload.los_op || "", 
    los: currentPayload.length_of_stay || "",
  });
}, [open, currentPayload]);

const handleApply = () => {
  const modalOwnedIds = getModalOwnedIds();
  const modalOwnedNames = getModalOwnedNames();

  // anything currently applied that this modal's own dropdown never produced
  // — i.e. it came from the toolbar's "Select Files" menu — must be preserved
  const preservedHeaderIds = (currentPayload.header_id || []).filter(
    (id) => !modalOwnedIds.has(id),
  );
  const preservedFileTypes = (currentPayload.file_type || []).filter(
    (name) => !modalOwnedNames.has(name),
  );

  // this modal's own current selection
  const selectedHeaderIds = Array.from(
    new Set(
      filters.file.flatMap(
        (name) => Array.from(fileNameToHeaderIdsRef.current[name] || []),
      ),
    ),
  );

  dispatch(
    setPayload({
      priority_value: filters.priority.map((item) =>
        Number(String(item).replace("P", ""))
      ),
      episode_identifier: filters.episode,
      file_type: Array.from(new Set([...preservedFileTypes, ...filters.file])),
      header_id: Array.from(new Set([...preservedHeaderIds, ...selectedHeaderIds])),
      principal_diagonsis: filters.principalDiagnosis,
      drg: filters.drg,
      case_mix_speciality: filters.specialities,
      insurer_identifier: filters.healthfund,
      admission_date_from: formatDate(filters.admissionFrom),
      admission_date_to: formatDate(filters.admissionTo),
      separation_date_from: formatDate(filters.separationFrom),
      separation_date_to: formatDate(filters.separationTo),
      audit_rule_category: filters.auditRuleCategory,
      coder_name: filters.codername,
      status: filters.status,
      audit_ref_no: filters.auditRuleReferenceNo,
      los_op: filters.losOperator,
      length_of_stay: filters.los,
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    })
  );

  onClose();
};

  const handleRemoveFilter = (key, value) => {
  const current = breadcomPayload[key];

  dispatch(
    setPayload({
      [key]: Array.isArray(current)
        ? current.filter((item) => item !== value)
        : "",
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView, 
      recall:isRecalledView
    })
  );
};

  // Determine if "to" date fields should be disabled
  const isAdmissionToDisabled = !filters.admissionFrom;
  const isSeparationToDisabled = !filters.separationFrom;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        // Only close when explicitly triggered (like clicking the X button)
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      fullWidth
      maxWidth="md"
      classes={{ paper: "enhance-filter-modal" }}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(0,0,0,0.5)" },
        },
      }}
    >
      <Box className="enhance-filter-header">
        <Box>
          <Typography className="enhance-filter-title">
            Filter Records
          </Typography>
          <Typography className="enhance-filter-subtitle">
            Refine your Enhance Workflow workspace
          </Typography>
          <Box mt={1}>
            <FilterBreadcrumbs
              filters={filters}
              labels={FILTER_LABELS}
              onRemove={(key, value) => {
                setFilters((prev) => ({
                  ...prev,
                  [key]: Array.isArray(prev[key])
                    ? prev[key].filter((item) => item !== value)
                    : "",
                }));
              }}
            />
          </Box>
        </Box>

        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent className="enhance-filter-body">
        <Box className="enhance-filter-scroll-area">
          <Typography className="enhance-filter-section-heading-first">
            FREQUENTLY USED
          </Typography>

          <Box className="enhance-filter-row enhance-filter-row-1">
            <MultiSelectDropdown
              label="Priority"
              placeholder="Select priority"
              options={priorities}
              value={filters.priority}
              onChange={(value) => handleInput("priority", value)}
            />
          </Box>

          <Box className="enhance-filter-row enhance-filter-row-3">
            <Box className="enhance-filter-field">
              <MultiSelectDropdown
                label="Episode Identifier"
                placeholder="Search Episode"
                options={episode.data}
                value={filters.episode}
                onChange={(value) => handleInput("episode", value)}
                loading={
                  episode.status === REQUEST_STATUS.LOADING &&
                  dropdownState.episode.page === 1
                }
                loadingMore={
                  episode.status === REQUEST_STATUS.LOADING &&
                  dropdownState.episode.page > 1
                }
                hasMore={episode.hasMore}
                onLoadMore={handleLoadMore(
                  "episode",
                  getEpisodeIdentifiers,
                  episode.hasMore,
                )}
                onInputChange={handleSearch("episode", getEpisodeIdentifiers)}
              />
            </Box>

            <Box className="enhance-filter-field">
              <MultiSelectDropdown
                label="Audit Rule Reference No"
                placeholder="Search Reference No"
                options={auditRuleReferenceNo.data}
                value={filters.auditRuleReferenceNo}
                onChange={(value) => handleInput("auditRuleReferenceNo", value)}
                loading={
                  auditRuleReferenceNo.status === REQUEST_STATUS.LOADING &&
                  dropdownState.episode.page === 1
                }
                loadingMore={
                  auditRuleReferenceNo.status === REQUEST_STATUS.LOADING &&
                  dropdownState.auditRuleReferenceNo.page > 1
                }
                hasMore={auditRuleReferenceNo.hasMore}
                onLoadMore={handleLoadMore(
                  "auditRuleReferenceNo",
                  getAuditRuleRefNo,
                  auditRuleReferenceNo.hasMore,
                )}
                onInputChange={handleSearch(
                  "auditRuleReferenceNo",
                  getAuditRuleRefNo,
                )}
              />
            </Box>

            <MultiSelectDropdown
              label="Coder Name"
              placeholder="Search Coders"
              options={codername.data.map((c) => c.username)}
              value={filters.codername}
              onChange={(value) => handleInput("codername", value)}
              loading={
                codername.status === REQUEST_STATUS.LOADING &&
                dropdownState.codername.page === 1
              }
              loadingMore={
                codername.status === REQUEST_STATUS.LOADING &&
                dropdownState.codername.page > 1
              }
              hasMore={codername.hasMore}
              onLoadMore={handleLoadMore(
                "codername",
                getCoderName,
                codername.hasMore,
              )}
              onInputChange={handleSearch("codername", getCoderName)}
            />
          </Box>

          <Box className="enhance-filter-row enhance-filter-row-3">
           <MultiSelectDropdown
  label="File Name"
  placeholder="Search File"
  options={[...new Set(file.data.map((f) => f.file_name))]}
  value={filters.file}
  onChange={(value) => handleInput("file", value)}
  loadingMore={file.status === REQUEST_STATUS.LOADING && dropdownState.file.page > 1}
  hasMore={file.hasMore}
  onLoadMore={handleLoadMore("file", getFileNames, file.hasMore)}
  onInputChange={handleSearch("file", getFileNames)}
/>
          </Box>

          <Typography className="enhance-filter-section-heading">
            CLINICAL FILTERS
          </Typography>

          <Box className="enhance-filter-row enhance-filter-row-4">
            <MultiSelectDropdown
              label="Principal Diagnosis"
              placeholder="Search Diagnosis"
              options={principalDiagnosis.data}
              value={filters.principalDiagnosis}
              onChange={(value) => handleInput("principalDiagnosis", value)}
              loading={
                principalDiagnosis.status === REQUEST_STATUS.LOADING &&
                dropdownState.principalDiagnosis.page === 1
              }
              loadingMore={
                principalDiagnosis.status === REQUEST_STATUS.LOADING &&
                dropdownState.principalDiagnosis.page > 1
              }
              hasMore={principalDiagnosis.hasMore}
              onLoadMore={handleLoadMore(
                "principalDiagnosis",
                getPrincipalDiagnosis,
                principalDiagnosis.hasMore,
              )}
              onInputChange={handleSearch(
                "principalDiagnosis",
                getPrincipalDiagnosis,
              )}
            />

            <MultiSelectDropdown
              label="DRG"
              placeholder="Select DRG"
              options={drg.data}
              value={filters.drg}
              onChange={(value) => handleInput("drg", value)}
              loading={
                drg.status === REQUEST_STATUS.LOADING &&
                dropdownState.drg.page === 1
              }
              loadingMore={
                drg.status === REQUEST_STATUS.LOADING &&
                dropdownState.drg.page > 1
              }
              hasMore={drg.hasMore}
              onLoadMore={handleLoadMore("drg", getDrg, drg.hasMore)}
              onInputChange={handleSearch("drg", getDrg)}
            />

            <MultiSelectDropdown
              label="Speciality"
              placeholder="Search Speciality"
              options={specialities.data}
              value={filters.specialities}
              onChange={(value) => handleInput("specialities", value)}
              loading={
                specialities.status === REQUEST_STATUS.LOADING &&
                dropdownState?.specialities?.page === 1
              }
              loadingMore={
                specialities.status === REQUEST_STATUS.LOADING &&
                dropdownState.specialities.page > 1
              }
              hasMore={specialities.hasMore}
              onLoadMore={handleLoadMore(
                "speciality",
                getSpecialitiesFilter,
                specialities.hasMore,
              )}
              onInputChange={handleSearch("speciality", getSpecialitiesFilter)}
            />

            <MultiSelectDropdown
              label="Health Fund"
              placeholder="Select fund"
              options={healthfund.data}
              value={filters.healthfund}
              onChange={(value) => handleInput("healthfund", value)}
              loading={
                healthfund.status === REQUEST_STATUS.LOADING &&
                dropdownState?.healthfund?.page === 1
              }
              loadingMore={
                healthfund.status === REQUEST_STATUS.LOADING &&
                dropdownState.healthfund.page > 1
              }
              hasMore={healthfund.hasMore}
              onLoadMore={handleLoadMore(
                "healthfund",
                getHealthFund,
                healthfund.hasMore,
              )}
              onInputChange={handleSearch("healthfund", getHealthFund)}
            />
          </Box>

          <Typography className="enhance-filter-section-heading">
            DATE FILTERS
          </Typography>

          <Box className="enhance-filter-row enhance-filter-row-2">
            <Box className="enhance-filter-date-group">
              <FieldLabel>Admission Date</FieldLabel>
              <Box className="enhance-filter-date-group-inputs">
                <TextField
                  type="date"
                  value={filters.admissionFrom}
                  onChange={(e) => handleInput("admissionFrom", e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ notched: false }}
                  fullWidth
                />
                <Typography className="enhance-filter-date-group-to">
                  to
                </Typography>
                <Tooltip
                  title={
                    isAdmissionToDisabled
                      ? "Please select a 'From' date first"
                      : ""
                  }
                  arrow
                  disableHoverListener={!isAdmissionToDisabled}
                >
                  <span style={{ width: "100%" }}>
                    <TextField
                      type="date"
                      value={filters.admissionTo}
                      onChange={(e) =>
                        handleInput("admissionTo", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        notched: false,
                        inputProps: {
                          min: filters.admissionFrom || undefined,
                        },
                      }}
                      disabled={isAdmissionToDisabled}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                          cursor: "not-allowed",
                        },
                      }}
                    />
                  </span>
                </Tooltip>
              </Box>
            </Box>

            <Box className="enhance-filter-date-group">
              <FieldLabel>Separation Date</FieldLabel>
              <Box className="enhance-filter-date-group-inputs">
                <TextField
                  type="date"
                  value={filters.separationFrom}
                  onChange={(e) =>
                    handleInput("separationFrom", e.target.value)
                  }
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ notched: false }}
                  fullWidth
                />
                <Typography className="enhance-filter-date-group-to">
                  to
                </Typography>
                <Tooltip
                  title={
                    isSeparationToDisabled
                      ? "Please select a 'From' date first"
                      : ""
                  }
                  arrow
                  disableHoverListener={!isSeparationToDisabled}
                >
                  <span style={{ width: "100%" }}>
                    <TextField
                      type="date"
                      value={filters.separationTo}
                      onChange={(e) =>
                        handleInput("separationTo", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        notched: false,
                        inputProps: {
                          min: filters.separationFrom || undefined,
                        },
                      }}
                      disabled={isSeparationToDisabled}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                          cursor: "not-allowed",
                        },
                      }}
                    />
                  </span>
                </Tooltip>
              </Box>
            </Box>
          </Box>

          <Accordion defaultExpanded className="enhance-filter-advanced">
            <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
              <Box display="flex" alignItems="center" gap={1}>
                <TuneIcon fontSize="small" />
                <Typography className="enhance-filter-advanced-title">
                  Advanced Filters
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              <Box className="enhance-filter-row enhance-filter-row-2">
                <Box className="enhance-filter-field">
                  <MultiSelectDropdown
                    label="Audit Rule Category"
                    placeholder="Search Category"
                    options={auditRuleCategory.data}
                    value={filters.auditRuleCategory}
                    onChange={(value) =>
                      handleInput("auditRuleCategory", value)
                    }
                    loadingMore={
                      auditRuleCategory.status === REQUEST_STATUS.LOADING &&
                      dropdownState.auditRuleCategory.page > 1
                    }
                    hasMore={auditRuleCategory.hasMore}
                    onLoadMore={handleLoadMore(
                      "auditRuleCategory",
                      getAuditRuleCategory,
                      auditRuleCategory.hasMore,
                    )}
                    onInputChange={handleSearch(
                      "auditRuleCategory",
                      getAuditRuleCategory,
                    )}
                  />
                </Box>

                {/* <MultiSelectDropdown label="Audit Status" /> */}

                <MultiSelectDropdown
                  label="Status"
                  options={workflowStatus.data}
                  placeholder="Select Status"
                  value={filters.status}
                  onChange={(value) => handleInput("status", value)}
                  loadingMore={
                    workflowStatus.status === REQUEST_STATUS.LOADING &&
                    dropdownState.status.page > 1
                  }
                  hasMore={workflowStatus.hasMore}
                  onLoadMore={handleLoadMore(
                    "status",
                    getStatus,
                    workflowStatus.hasMore,
                  )}
                  onInputChange={handleSearch("status", getStatus)}
                />
              </Box>
              <Box className="enhance-filter-plus-row enhance-filter-plus-row-2">
                <MultiSelectDropdown
                  multiple={false}
                  label="LOS Operator"
                  placeholder="Select operator"
                  options={operatorOptions}
                  value={filters.losOperator}
                  onChange={(value) => handleInput("losOperator", value)}
                />

                <Box className="enhance-filter-plus-field">
                  <FieldLabel>Length of Stay (LOS)</FieldLabel>
                  <TextField
                    placeholder="Enter days"
                    value={filters.los}
                    onChange={(e) => handleInput("los", e.target.value)}
                    disabled={isLosDisabled}
                    className={isLosDisabled ? "age-disabled-field" : ""}
                    fullWidth
                    InputProps={{ notched: false }}
                  />
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box className="enhance-filter-footer">
          <Button
            size="small"
            startIcon={<RestartAltIcon fontSize="small" />}
            color="error"
            onClick={handleClear}
          >
            Clear All
          </Button>

          <Box display="flex" gap={1.5}>
            <Button size="small" variant="outlined" onClick={onClose}>
              Cancel
            </Button>

            <Button
              size="small"
              variant="contained"
              className="enhance-filter-apply-btn"
              onClick={handleApply}
            >
              Apply Filters
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EnhanceWorkflowFilterModal;